import { useUser as useSharedUser } from '@memorai/api-hooks';
import { useAuth } from '../../contexts/AuthContext';

export const useUser = () => {
    const { user: authUser } = useAuth();
    return useSharedUser(authUser?.id);
};
